/**
 * 区分 tradeType（companies.trade_type）
 * 出典：仕様書に値なし（13 章 C-39）
 * 【仮置き】入力文書に値が無い。業務側の確認で差し替える
 */
export const TRADE_TYPE_VALUES = ['quasiMandate', 'contracting', 'dispatch', 'other'] as const;

export type TradeType = (typeof TRADE_TYPE_VALUES)[number];

export const TRADE_TYPE_LABELS: Readonly<Record<TradeType, string>> = {
  quasiMandate: '準委任',
  contracting: '請負',
  dispatch: '派遣',
  other: 'その他',
};
